(function () {
  var phrases = [
    'Search products...',
    'Search curtains...',
    'Search blinds...',
    'Search bedding...',
    'Search fabric...',
    'Search by brand...',
    'Search by colour...'
  ];

  var fallbackPlaceholder = 'Search...';
  var typingDelay = 80;
  var deletingDelay = 35;
  var pauseDelay = 3500;
  var maxWaitMs = 10000;
  var initializedAttribute = 'data-search-placeholder-initialized';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function init(input) {
    if (input.hasAttribute(initializedAttribute)) return;

    input.setAttribute(initializedAttribute, 'true');

    if (prefersReducedMotion()) {
      input.setAttribute('placeholder', fallbackPlaceholder);
      return;
    }

    var phraseIndex = 0;
    var charIndex = 0;
    var deleting = false;

    function typePlaceholder() {
      if (!document.body.contains(input)) return;

      if (document.activeElement === input || input.value) {
        input.setAttribute('placeholder', fallbackPlaceholder);
        window.setTimeout(typePlaceholder, pauseDelay);
        return;
      }

      var phrase = phrases[phraseIndex];

      if (!deleting) {
        input.setAttribute('placeholder', phrase.substring(0, charIndex));

        if (charIndex < phrase.length) {
          charIndex += 1;
          window.setTimeout(typePlaceholder, typingDelay);
        } else {
          deleting = true;
          window.setTimeout(typePlaceholder, pauseDelay);
        }
      } else if (deleting && charIndex > 0) {
        charIndex -= 1;
        input.setAttribute('placeholder', phrase.substring(0, charIndex));
        window.setTimeout(typePlaceholder, deletingDelay);
      } else {
        deleting = false;
        phraseIndex = (phraseIndex + 1) % phrases.length;
        window.setTimeout(typePlaceholder, typingDelay);
      }
    }

    typePlaceholder();
  }

  function waitForSearchInput(startTime) {
    var input = document.querySelector('#search_query_top');

    if (input) {
      init(input);
      return;
    }

    if (Date.now() - startTime < maxWaitMs) {
      window.setTimeout(function () {
        waitForSearchInput(startTime);
      }, 100);
    }
  }

  waitForSearchInput(Date.now());
})();
